import { TFunction } from 'i18next';
import * as yup from 'yup';

export const validationSchema = (t: TFunction) =>
  yup.object({
    autocompleteName: yup.string().required(t('proposeRestaurant.restaurantNameRequired')).trim().typeError(t('proposeRestaurant.restaurantNameInvalid')),

    placeId: yup.string().typeError(t('proposeRestaurant.onlyPlaceError')),


    phoneNumber: yup
      .string()
      .required(t('proposeRestaurant.phoneNumberRequired'))
      .matches(/^(\+33|0)[\s-]?[67][\s-]?(\d[\s-]?){8}$/, {
        message: t('proposeRestaurant.phoneNumberFormatStatus'),
        excludeEmptyString: true
      }),

    firstName: yup.string().required(t('proposeRestaurant.firstNameRequired')).trim(),

    lastName: yup.string().required(t('proposeRestaurant.lastNameRequired')).trim(),


    isPlaceAlreadyRegistered: yup.boolean(),

    suppliers: yup.array().of(yup.string()).required('Au moins un fournisseur est requis'),
    company: yup.string().required('La société est requise')
  });

export type AddRestaurantSchemaType = yup.InferType<ReturnType<typeof validationSchema>>;
